import { deepmerge } from "@mui/utils";
function createEditorTheme(editorThemeStyles = {}, defaultThemeStyles = {}) {
  const mergedStyles = deepmerge(defaultThemeStyles, editorThemeStyles);
  const theme = {};
  for (const [key] of Object.entries(mergedStyles)) {
    switch (key) {
      case "heading":
      case "text":
      case "embedBlock": {
        theme[key] ??= {};
        for (const subKey of Object.keys(mergedStyles[key] ?? {})) {
          theme[key][subKey] = `tidalEditorLocal_${subKey}`;
        }
        break;
      }
      case "list": {
        theme[key] ??= {};
        for (const [subKey, subValue] of Object.entries(mergedStyles[key] ?? {})) {
          if (subKey === "nested") {
            theme[key][subKey] ??= {};
            if (subValue.list) theme[key][subKey].list = `tidalEditorLocal_${subKey}_list`;
            if (subValue.listitem) theme[key][subKey].listitem = `tidalEditorLocal_${subKey}_listitem`;
          } else {
            theme[key][subKey] = `tidalEditorLocal_${subKey}`;
          }
        }
        break;
      }
      default:
        theme[key] = `tidalEditorLocal_${key}`;
        break;
    }
  }
  return theme;
}
export {
  createEditorTheme
};
//# sourceMappingURL=createEditorTheme.js.map
